import {IAuthenticationType} from "../index";
import {AuthenticationTypeFlag} from "../constants/AuthenticationTypeFlag";
import {global} from "../appContext";

export namespace nsLogin {

    export function getFederatedLoginUrl(authenticationType: IAuthenticationType, orgnr: string, redirectUrl?: string) {
        let loginurl = authenticationType.loginurl

        if (loginurl == 'local') {
            // seems we're not using federation - just return the loginurl as is
            return loginurl
        }

        if (authenticationType.flag == AuthenticationTypeFlag.AAD_FEDERATION) {
            loginurl = loginurl.replace(/\/aad\//, `/aad-${orgnr}/`)
        } else {
            // Replace login url's company id placeholder (if given) with the actual company id
            loginurl = loginurl.replace('[companyid]', orgnr)
        }

        // Prepare the redirect url (full URL — post-SSO decode uses `new URL(...)`).
        // Prefer intendedHash: org select rewrites the location to #/formlogin/{orgnr}, and
        // federated SSO leaves the SPA so only this encoded value survives the round-trip.
        const redirecturl = redirectUrl
            ? encodeRedirectUrl(redirectUrl)
            : (() => {
                const intended = global.login.intendedHash;
                if (intended) {
                    return encodeRedirectUrl(document.location.origin + intended);
                }
                let url = document.location.href
                // Strip "#/formlogin" from redirect url (keeping any other intended routes)
                if (/#\/formlogin(?:$|\/.*?$)/.test(url)) {
                    const redirectIndex = url.lastIndexOf('#/formlogin');
                    url = url.substring(0, redirectIndex);
                }
                return encodeRedirectUrl(url)
            })()

        // Append redirect to login url
        if (loginurl.endsWith('mega.eadm.no')) {
            // replace login url's dummy redirect url
            return loginurl.replace('mega.eadm.no', redirecturl)
        } else {
            // just append it to the end
            return loginurl + redirecturl
        }
    }

    export function encodeRedirectUrl(url: string): string {
        return encodeURIComponent(btoa(url))
    }

    export function decodeRedirectUrl(url: string): string {
        let ret = url
        try {
            ret = decodeURIComponent(ret)
        } catch {
        }
        try {
            ret = atob(ret)
        } catch {
        }
        return ret ?? null
    }

}